import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=38c7ac02&scoped=true"
import script from "./GlobalAlert.vue?vue&type=script&lang=js"
export * from "./GlobalAlert.vue?vue&type=script&lang=js"
import style0 from "./GlobalAlert.vue?vue&type=style&index=0&id=38c7ac02&prod&scoped=true&lang=css"
import style1 from "./GlobalAlert.vue?vue&type=style&index=1&id=38c7ac02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c7ac02",
  null
  
)

export default component.exports